import styled from "styled-components";

const MatrixContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media(max-width: 900px) {
    display: block;
  }
`;

export const Ulcontainer = styled.ul`
		display: flex;
		width: 100%;
		flex-direction: column;
		transition: 150ms ease;


		li.list-component-child{
			display: flex;
			flex-direction: row;
			position: relative;

			align-items: center;

			border-radius: 10px;
			border: 1px solid var(--border-color);
			box-shadow: 0 2px 1px -1px var(--border-color);
			background: var(--card-background);
			color: var(--default-color-font);

			font-size: 0.83rem;

			padding: 4px;
			margin: 5px 0;

			transition: 150ms ease;


			@media(max-width: 600px){
				flex-direction: column;
			}

			&.is-children{
				margin-bottom: 0.5rem;
				padding: 0;
				padding-left: 4px;
				border-bottom: none;
			}
		}

		li.list-component-header{
			display: flex;
			flex-direction: row;

			border-bottom: 1px solid var(--border-color);

			font-size: 0.9rem;

			padding: 4px;
			margin: 5px 0;

			position: sticky;
			top: 0;
			background: var(--input-background-color);
			color: var(--default-color-font);
			z-index: 2;
      font-weight: bold;
      
      @media(max-width: 600px){
        display: none;
      }
		}

		&:hover{
			li.list-component-child{
				box-shadow: none;
				&:hover{
					box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 8px;
				}
			}
		}
`;

export const SpanStyled = styled.span`
    font-size: 0.83rem;
    align-self:flex-end;
    margin-bottom:0.25rem;  
`;

export const UlTable = styled.ul`
		display: flex;
		width: 100%;
		flex-direction: column;
		transition: 150ms ease;
        margin: 8px 0;


        li.list-component-child{
            display: flex;
            flex-direction: row;
            position: relative;
            align-items: center;
            
            margin: 0;
            padding: 4px;
            border: none;
            border-radius: 0;
            border-bottom: 1px solid var(--border-color);
            background-color: var(--li-child-striped);
            color: var(--default-color-font);
            font-size: 0.83rem;

            &:nth-child(odd){
                background-color: var(--li-child-color);
            }
            @media(max-width: 600px){
				flex-direction: column;
			}
        }

		li.list-component-header{
			display: flex;
			flex-direction: row;
			font-size: 0.9rem;

			padding: 4px;

			position: sticky;
			top: 0;
			background: var(--input-background-color);
			color: var(--default-color-font);
			z-index: 2;
            font-weight: bold;

            border-bottom: 1px solid var(--border-color);
            background: var(--li-header-color);

			:not(.always){
					@media(max-width: 600px){
					display: none;
				}
			}

			&.always{
				padding:0;
				flex-wrap:wrap;
			}
		}

		&:hover{
			li.list-component-child{
				box-shadow: none;
				&:hover{
					box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 8px;
				}
			}
		}
       
`;

export default MatrixContainer;
